/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject} from '@angular/core';
import template from './user-list-page.component.html';
import {AdminListColumn, AdminResourceListPageBase} from '../../common/controller/admin-resource-list-page-base';
import {LocalNetworkProfile} from '../../../components/session/local-network-profile';

@Component({
  standalone: false,
  selector: 'adn-user-list-page',
  template
})
export class UserListPageComponent extends AdminResourceListPageBase {
  readonly itemStateName = 'app.adm.users.user';

  readonly columns: AdminListColumn[] = [
    {param: 'username'},
    {param: 'name'},
    {param: 'lastLogin'},
    {param: 'lastPasswordChange'},
    {param: 'createTime'},
    {param: '', label: 'role', sortable: false}
  ];

  constructor(@Inject(LocalNetworkProfile) LocalNetworkProfile: any) {
    super(LocalNetworkProfile);
  }
}
